import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./media_screen.module.scss";

export const MediaScreen = () => {
  return (
    <div className={styles.boxItem}>
      <Skeleton width="100%" height="120px" />
      <Skeleton width="100%" height="25px" />
      <Skeleton width="100%" height="20px" />
      <Skeleton width="39px" height="20px" />
    </div>
  );
};

export default MediaScreen;
